import { FETCH_GET_OPTIONS, FETCH_POST_OPTIONS, FETCH_PUT_OPTIONS } from '../utils/constants/RestHelpers';
import { PROMISE_ERROR_CATCH, PARSE_JSON_AND_CHECK_STATUS_CODE } from '../utils/constants/ServerResponseStatusCheck'
import {
    getUserProductItemBySubmissionIdURL,
    updateProductURL,
    getUserProductListByUrlKeyURL,
    getSortedProductVersionsURL,
    getProductVersionCompatibilitiesURL,
    getUserProductItemBySubmissionIdForAdminURL,
    getUserProductPreviewURL,
    getLiveProductsURL,
} from '../utils/urls/';

export const getUserProductItemBySubmissionId = submissionId => new Promise((res, rej) => {
    fetch( getUserProductItemBySubmissionIdURL(submissionId), FETCH_GET_OPTIONS)
        .then(PARSE_JSON_AND_CHECK_STATUS_CODE).then(res).catch(rej)
}).catch(PROMISE_ERROR_CATCH);

//TEMP : hotfix for SP version details to work
export const getUserProductItemBySubmissionIdforSP = submissionId => {
    return new Promise((resolve, reject) => {
        fetch( getUserProductItemBySubmissionIdURL(submissionId), FETCH_GET_OPTIONS)
            .then(PARSE_JSON_AND_CHECK_STATUS_CODE)
            .then(resolve).catch(reject)
    }).catch(PROMISE_ERROR_CATCH);
};

export const updateProduct = (data) => {
    return new Promise((resolve, reject) => {
        return fetch( updateProductURL(), {...FETCH_PUT_OPTIONS, body:JSON.stringify(data)})
            .then(PARSE_JSON_AND_CHECK_STATUS_CODE)
            .then(resolve).catch(reject)
    }).catch(PROMISE_ERROR_CATCH);
};

export const getUserProductListByUrlKey = (url_key) => {
    return new Promise((resolve, reject) => {
        fetch( getUserProductListByUrlKeyURL(url_key) , FETCH_GET_OPTIONS)
            .then(PARSE_JSON_AND_CHECK_STATUS_CODE)
            .then(resolve).catch(reject)
    }).catch(PROMISE_ERROR_CATCH);
};

export const sortProductVersions = (url_key,order,elm) => {
    return new Promise((resolve, reject) => {
        fetch( getSortedProductVersionsURL(url_key, order, elm), FETCH_GET_OPTIONS)
            .then(PARSE_JSON_AND_CHECK_STATUS_CODE)
            .then(resolve).catch(reject)
    }).catch(PROMISE_ERROR_CATCH);
};

export const getCheckIfPatchVersion = (url_key,order,elm) => {
    return new Promise((resolve, reject) => {
        fetch( getSortedProductVersionsURL(url_key, order, elm), FETCH_GET_OPTIONS)
            .then(PARSE_JSON_AND_CHECK_STATUS_CODE)
            .then(resolve).catch(reject)
    }).catch(PROMISE_ERROR_CATCH);
};

export const getProductVersionCompatibilities = submissionId => (
    new Promise((res, rej) => {
        fetch(getProductVersionCompatibilitiesURL(submissionId), FETCH_GET_OPTIONS)
            .then(PARSE_JSON_AND_CHECK_STATUS_CODE)
            .then(data => ({submissionId, data}) )
            .then(res).catch(rej)
    }).catch(PROMISE_ERROR_CATCH)
);

export const getUserProductPreview= submissionId => new Promise((res, rej) => {
    fetch(getUserProductPreviewURL(submissionId) , FETCH_GET_OPTIONS)
        .then(PARSE_JSON_AND_CHECK_STATUS_CODE).then(res).catch(rej)
}).catch(PROMISE_ERROR_CATCH);

export const getUserProductPreviewForAdmin = submissionId => new Promise((res, rej) => {
    fetch( getUserProductItemBySubmissionIdForAdminURL(submissionId) , FETCH_GET_OPTIONS)
        .then(PARSE_JSON_AND_CHECK_STATUS_CODE).then(res).catch(rej)
}).catch(PROMISE_ERROR_CATCH);

export const getLiveProducts = () => {
    return new Promise((resolve, reject) => {
        fetch( getLiveProductsURL, FETCH_GET_OPTIONS)
            .then(PARSE_JSON_AND_CHECK_STATUS_CODE)
            .then(resolve).catch(reject)
    }).catch(PROMISE_ERROR_CATCH);
};


